import { ReactElement } from "react";

const SyfLoader = (): ReactElement => {
  return (
    <div
      className="flex items-center relative justify-center h-[48px] w-[36px]"
      role="img"
      aria-label="Content Loading"
      id="syf-loader"
    >
      <div className="w-[24%] h-full absolute bottom-0 left-0 animate-move-about-left bg-syfYellow" />
      <div className="w-[24%] h-full absolute animate-move-about-middle bg-syfYellow" />
      <div className="w-[24%] h-full absolute top-0 right-0 animate-move-about-right bg-syfYellow" />
    </div>
  );
};

export default SyfLoader;
